import React from 'react';
import ReactDOM from 'react-dom';
import { Container } from 'reactstrap';
import LoadingBar from 'react-redux-loading-bar';
import { Route, Switch, BrowserRouter } from 'react-router-dom'

import { Provider } from 'react-redux'
import configureStore from './store/store'
import 'bootstrap/dist/css/bootstrap.css';
import './css/index.css';
import './css/table.css'

import * as serviceWorker from './serviceWorker';
import { signalRRegistration } from './middleware/signalRRegistration';

// import Main from './containers/main';

//Componentes
// import NavigationBar from './components/common/navigationBar';
import Live from './containers/live';
import ScratchResults from './containers/scratchResults';
import ScratchStartList from './containers/scratchStartList';
import PointsRaceStartList from './containers/pointsraceStartList';
import PointsRaceResults from './containers/pointsraceResults';
import races from './containers/races';
import ttResults from './containers/ttResults'
import ttStartList from './containers/ttStartList';
import ttRound1 from './containers/ttRound1';
import KeirinStartList from './containers/keirinStartList';
import KeirinResults from './containers/keirinResults';
import Footer from './components/common/Footer';
import Header from './components/common/Header';
import SprintTournamentStartList from './containers/sprintTournamentStartList';
import SprintTournamentResults from './containers/sprintTournamentResults';

const rootElement = document.getElementById('root')

const store = configureStore();
// const AppName = "appName";
signalRRegistration(store);

const NoMatch = ({ location }) => {
  return (
    <div>
      <h3>
        No match for <code>{location.pathname}</code>
      </h3>
    </div>
  );
}

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      {/* <Switch>
        <Route exact path={`/`} render={() => (<Redirect to={{ pathname: `/${AppName}` }} />)}></Route>
        <Route path={`/${AppName}`} component={Main} />
        <Route exact path={`/`} component={Main} />
        <Route path={`/Scratch/startlist/:raceCode`} component={ScratchStartList} />
      </Switch> */}
      <div className="app-content" id="cl-wrapper">
        {/* <NavigationBar /> */}
        <Header />
        <LoadingBar />
        <Container id="pcont" fluid>
          <div className="cl-mcont">

            <Switch>
              {/* <Route exact path={`${match.url}`} render={() => (<Redirect to={{ pathname: `${match.url}/dashboard` }} />)}></Route> */}
              {/* <Route
              path={`${match.url}/Races`}
              render={(homeProps) => (
                <Switch>
                  <Route path={`${homeProps.match.url}`} component={races}></Route>
                </Switch>
              )}
            /> */}


              <Route path={`/`} exact component={races} />

              <Route path={`/Races`} component={races} />
              <Route path={`/Scratch/startlist/:raceCode`} component={ScratchStartList} />
              <Route path={`/Scratch/results/:raceCode`} component={ScratchResults} />
              <Route path={`/PointsRace/startlist/:raceCode`} component={PointsRaceStartList} />
              <Route path={`/PointsRace/results/:raceCode`} component={PointsRaceResults} />
              <Route path={`/TT/startlist/:raceCode/:fase`} component={ttStartList} />
              <Route path={`/TT/results/:raceCode/:fase`} component={ttResults} />
              <Route path={`/TT/Round1/:raceCode/:fase`} component={ttRound1} />
              <Route path={`/Keirin/startlist/:raceCode`} component={KeirinStartList} />
              <Route path={`/Keirin/results/:raceCode`} component={KeirinResults} />
              <Route path={`/SprintTournament/startlist/:raceCode`} component={SprintTournamentStartList} />
              <Route path={`/SprintTournament/results/:raceCode`} component={SprintTournamentResults} />
              <Route path={`/Live`} component={Live} />
              <Route component={NoMatch} />
            </Switch>

          </div>
        </Container>
        <Footer />
      </div>
    </BrowserRouter>
  </Provider>,

  rootElement
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
